var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PerformanceUser'),_c('Expedition'),_c('HistoryRetur'),_c('ChartTransaction')],1)}
var staticRenderFns = []

export { render, staticRenderFns }